<template>
  <div class="view-gabarit">
    <h2 class="head-box-title flat">{{ $t('modal.deleteAccountValidation') }}</h2>
    <div class="cta-container">
      <button class="study-button" @click="() => $emit('closeModal')">{{ $t('cancel') }}</button>
      <button class="study-button main" @click="deleteAccount">{{ $t('validate') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['params'],

  methods: {
    deleteAccount() {
      this.$emit('closeModal');
      this.$store.dispatch('deleteAccount').then(() => {
        this.$router.push({ name: 'Logout' });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.view-gabarit {
  width: 680px;
  .cta-container {
    padding: 38px;
    text-align: center;
    button {
      margin: 0 1em;
    }
  }
}
</style>
